module.exports = __webpack_public_path__ + "static/media/CattlePlanning.a0a195ef.png";